import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import ROUTES from 'Utilities/routes';

const { BIDDING } = ANALYTICS_CATEGORIES;

const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface TriggerConfirmCancelBidOrOfferCTAClickedEventParams {
	errorMessage?: string;
	purchaseType: string;
	success: boolean;
}

export const triggerConfirmCancelBidOrOfferCTAClickedEvent = ({
	errorMessage,
	purchaseType,
	success,
}: TriggerConfirmCancelBidOrOfferCTAClickedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING,
		customData: {
			button_label: `Cancel ${purchaseType}`,
			...(success ? {} : { label: errorMessage }),
			success,
			url: ROUTES.VEHICLE.as(),
		},
		name: `dlr_confirm_cancel_${purchaseType}_button_clicked`,
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
